import * as React from 'react';
import {Text} from '@inlet/react-pixi';
import {TextStyle} from 'pixi.js';
import {ReactComponentWithContext} from '@gongxigames/framework/core/fragments/react';
import {CheatAction, ICheatsModuleContext} from '../CheatModuleInterfaces';

const style = new TextStyle({
    fontFamily: 'Arial',
    fontSize: 60,
    fontWeight: 'bold',
    align: 'right',
    fill: '#ffffff'
});

type ListSelectedFiltersProps = {
    x: number;
};

export class ListSelectedFilters extends ReactComponentWithContext<ICheatsModuleContext, ListSelectedFiltersProps> {
    public componentDidMount(): void {
        this.moduleContext.storage.on('cheatActions', () => this.forceUpdate(), this);
    }

    public componentWillUnmount(): void {
        this.moduleContext.storage.off('cheatActions', this);
    }

    protected unselectFilter(action: CheatAction): void {
        this.moduleContext.removeCheatAction(action);
    }

    protected getText(action: CheatAction, x: number, y: number): JSX.Element {
        return <Text
            text={action.id}
            key={action.id}
            interactive={true}
            buttonMode={true}
            pointertap={this.unselectFilter.bind(this, action)}
            x={x}
            y={y}
            anchor={[1, 0]}
            style={style}
        />;
    }

    public render(): JSX.Element[] {
        const {cheatActions = []} = this.moduleContext.storage.data || {};
        let y = 0;

        return cheatActions.map((action, index) => {
            y = 60 * index;

            return this.getText(action, this.props.x - 10, y);
        });
    }
}
